import { render } from "./DebtorMonthlyFormLink.vue?vue&type=template&id=1de3acbe"
import script from "./DebtorMonthlyFormLink.vue?vue&type=script&lang=js"
export * from "./DebtorMonthlyFormLink.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__